






















































































































































































































import { Vue, Component } from "vue-property-decorator";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperCase from "@/zh-website/src/components/website/Swiper/SwiperCase.vue";
import SwiperNew from "@/zh-website/src/components/website/Swiper/SwiperNew.vue";
import SwiperIndex from "@/zh-website/src/components/website/Swiper/SwiperIndex.vue";
import Report from "@/zh-website/src/components/website/Report.vue";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
import { HomeService } from "@/zh-website/src/views/Homes/service";
@Component({
  components: { SwiperNews, SwiperCase, SwiperNew, SwiperIndex, Report }
})
export default class Home extends Vue {
  isCollapse = true;
  jump = "/home/news/det/";
  train: any = [];
  publicity: any = [];
  lately: any = [];
  rightNew: any = [];
  leftNew: any = [];
  reportData:any={}
  newjump = "/home/news/det/";
  // 金刚区导航
  nav = [
    {
      img: require("../../assets/index_icon01.png"),
      name: "政企用户",
      desc: "企业数字化人才培养产品及解决方案",
      path: "/enterprise/page"
    },
    {
      img: require("../../assets/index_icon02.png"),
      name: "高校用户",
      desc: "院校ICT专业建设等整体解决方案",
      path: "/colleges/page"
    },
    {
      img: require("../../assets/index_icon03.png"),
      name: "个人用户",
      desc: "个人ICT学习和发展的全在线服务平台",
      path: "www.ictxuetang.com"
    },
    {
      img: require("../../assets/index_icon04.png"),
      name: "合作伙伴",
      desc: "专家、课程、渠道等相关合作及查询",
      path: "/partner/page"
    }
  ];
  //轮播图
  banner: any = [];
  caseList: any = [];
  newCourseList: any = [];
  newCollegeList: any = [];
  listCase: any = [];
  caseJump: any = "/home/details/";
  url = "https://www.zj-huawei.com";
  mounted() {
    this.getBanner();
    this.getCase();
    this._getRightNew();
    this.getReport();
    this.getNewArrival();
    window.sessionStorage.setItem("caseCode", JSON.stringify("0037004"));
    setTimeout(function() {
      const paramsString = location.search;
      const searchParams = new URLSearchParams(paramsString);

      const navigator = searchParams.get('navigator');
      console.log("start navigate: " + navigator);
      if (navigator && navigator != '') {
        location.hash = "#" + navigator;
      }
    }, 1500);
  }
  async getReport(){
    NewsService.getReportList({
        pageNum: 1,
        pageSize: 1,
        timeFrameCode: ''
      }).then((res: any) => {
        console.log(res)
       if(res.success){
        this.reportData=res.data.list[0]
       }
      });
  }
  clickMask() {
    // window.location.href = "https://www.ictxuetang.com";
    window.open("https://www.ictxuetang.com", "_blank");
  }

  // 轮播图和宣传位
  async getBanner() {
    //宣传位调用接口获取
    HomeService.getBanner({
      type: 2,
      pageNum: 1,
      pageSize: 2
    }).then((res: any) => {
      this.publicity = res.data.list;
    });
    //轮播图调用接口获取
    HomeService.getBanner({
      type: 1,
      pageNum: 1,
      pageSize: 5
    }).then((res: any) => {
      this.banner = res.data.list;
    });
  }
  //获取成功案例
  async getCase() {
    this.caseList.length = 0;
    HomeService.getSuccessCase({ pageNum: 1, pageSize: 1000 }).then(
      (res: any) => {
        res.data.list.forEach(item => {
          this.caseList.push({
            jumpLink: item.jumpLink,
            dictName: item.classificationName,
            content1: item.title,
            field1: item.title,
            id: `all-success-case/detail/${item.id}`,
            field3: `background-image:url("${item.resourceUrl}")`
          });
        });
      }
    );
  }
  async getNewArrival() {
    this.newCollegeList = [];
    this.newCourseList = [];
    const NEW_COURSE = 1;
    HomeService.getNewArrival({ pageNum: 1, pageSize: 1000 }).then(
      (res: any) => {
        res.data.list.forEach(item => {
          const element = {
            jumpLink: item.dataType == 'custom' ? `/new/arrival/${item.id}` : item.jumpLink,
            dictName: item.subtitle,
            content1: item.title,
            field1: item.title,
            id: `all-success-case/detail/${item.id}`,
            field3: `background-image:url("${item.resourceUrl}")`
          };
          if (item.newArrivalCategory == NEW_COURSE) {
            this.newCourseList.push(element);
          } else {
            this.newCollegeList.push(element);
          }
        });
      }
    );
  }
  //时间戳转换
  timestampToTime(cjsj) {
    const date = new Date(cjsj); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + "-";
    const M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    const D = date.getDate() + " ";
    const h = date.getHours() + ":";
    const m = date.getMinutes() + ":";
    const s = date.getSeconds();
    // return Y+M+D+h+m+s
    return Y + M + D;
  }
  //右侧新闻动态
  async _getRightNew() {
    NewsService.getNewsList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.leftNew = {};
          this.rightNew = [];
        }
      }
    );
  }
}
